export const translations = {
    english: {
        translation0: "Add new story",
        translation1: "New Story",
        translation2: "My Stories",
        translation3: "SHARED WITH ME",
        translation4: "STORIES",
        translation5: "VIDEO TUTORIAL",
        translation6: "ABOUT MiCreate",
        translation7: "LOGOUT",
        translation8: "Shared With Me",
        translation9: "Share your story with friends.",
        translation10: "Email",
        translation11: "OK",
        translation12: "HOME",    // !
        translation13: "PAGES",    // !
        translation14: "TOOLS",    // !
        translation15: "NEXT",
        translation16: "ADD PAGE",
        translation17: "BACK",
        translation18: "BACKGROUNDS",
        translation19: "OBJECTS",
        translation20: "CHARACTERS",
        translation21: "TEXT BOXES",
        translation22: "Start typing...",
        translation23: "DONE",   // !
        translation24: "Page",
        translation25: "Cover page",
        translation26: "Password",
        translation27: "Forgot your password?",
        translation28: "OR",
        translation29: "CREATE NEW ACCOUNT",
        translation30: "Create your account",
        translation31: "SIGN UP",
        translation32: "LOGIN",
        translation33: "Reset your password",
        translation34: "SEND RESET LINK",
        translation35: "Reset email was sent",
        translation36: "Thank you!",
        translation37: "Your account was created. Before logging in, first confirm your email address.",
        translation38: "This project is part of a project that has received funding from the European Union’s Horizon 2020 research and innovation programme under grant agreement Nº822664",
        translation39: "CREATE NEW",
        translation40: "Want to Delete?",
        translation41: "Drawing page",
        translation42: "of",
        translation43: "Title",
        translation44: "Your name",
        translation45: "CANCEL AND QUIT",
        translation46: "CONTINUE",
        translation47: "EDIT TITLE",
        translation48: "FINISH",
        translation49: "title",
        translation50: "Preview and layout settings",
        translation51: "BACK",
        translation52: "CANCEL AND EXIT",
        translation54: "PUBLISH STORY",
        translation55: "Are you sure you want to delete this story? You will not be able to recover it.",
        translation56: "CANCEL",
        translation57: "DELETE",

        translation58: "Username or e-mail",
        translation59: "CHANGE LANGUAGE",
        translation60: "Add story title and your name",
        translation61: "Center",
        translation62: "Align bottom",
        translation63: "Align left",
        translation64: "Preview",
        translation65: "No story yet. Create one!",
    },
    slovenian: {
        translation0: "Dodaj novo zgodbo",
        translation1: "Nova zgodba",
        translation2: "Moje zgodbe",
        translation3: "DELJENO Z MANO",
        translation4: "ZGODBE",
        translation5: "VIDEO VODIČ",
        translation6: "O MiCreate",
        translation7: "ODJAVA",
        translation8: "Deljeno z mano",
        translation9: "Deli zgodbo s prijatelji",
        translation10: "E-naslov",
        translation11: "OK",
        translation12: "DOMOV",
        translation13: "STRANI",
        translation14: "ORODJA",
        translation15: "NAPREJ",
        translation16: "DODAJ STRAN",
        translation17: "NAZAJ",
        translation18: "OZADJA",
        translation19: "PREDMETI",
        translation20: "OSEBE",
        translation21: "PROSTOR ZA BESEDILO",
        translation22: "Začni pisati",
        translation23: "KONČANO",
        translation24: "Stran",
        translation25: "Prva stran",
        translation26: "Geslo",
        translation27: "Pozabljeno geslo?",
        translation28: "ALI",
        translation29: "USTVARI NOV RAČUN",
        translation30: "Ustvari svoj račun",
        translation31: "PRIJAVI SE",
        translation32: "VPIŠI SE",
        translation33: "Ponastavi svoje geslo",
        translation34: "POŠLJI PONASTAVLJENO POVEZAVO",
        translation35: "Ponastavljeno geslo je bilo poslano",
        translation36: "Hvala!",
        translation37: "Tvoj račun je bil ustvarjen. Pred projavo potrdi svoj e-poštni naslov",
        translation38: "Ta projekt je del projekta, ki je prejel finančna\nsredstva iz programa\nEvropske unije za raziskave in\ninovacije Horizont 2020 pod\nštevilko pogodbe o\nsubvenciji Nº822664.",
        translation39: "USTVARI",
        translation40: "Želite izbrisati?",
        translation41: "Rišem stran",
        translation42: "od",
        translation43: "Naslov",
        translation44: "Tvoje ime",
        translation45: "PREKLIČI IN ZAPRI",
        translation46: "NADALJUJ",
        translation47: "UREDITE NASLOV",
        translation48: "KONČAJ",
        translation49: "naslov",
        translation50: "Predogled in nastavitev postavitve",
        translation51: "NAZAJ",
        translation52: "ODPOVED IN IZHOD",
        translation54: "OBJAVI ZGODBO",
        translation55: "Ali ste prepričani, da želite izbrisati to zgodbo? Ne boste je mogli obnoviti.",
        translation56: "PREKLIČI",
        translation57: "IZBRIŠI",

        translation58: "Uporabniško ime ali geslo",
        translation59: "SPREMENI JEZIK",
        translation60: "Dodaj naslov in tvoje ime",
        translation61: "Na sredi",
        translation62: "Poravnaj navzdol",
        translation63: "Poravnaj levo",
        translation64: "Predogled",
        translation65: "Ni še nobene zgodbe. Ustvarite jo!",
    },
    danish: {
        translation0: "Tilføj ny historie",
        translation1: "Ny historie",
        translation2: "Mine historier",
        translation3: "DELT MED MIG",
        translation4: "HISTORIER",
        translation5: "VIDEOVEJLEDNING",
        translation6: "OM MiCREATE",
        translation7: "LOGOUT",
        translation8: "Delt med mig",
        translation9: "Del din historie med dine venner",
        translation10: "E-mail",
        translation11: "OK",
        translation12: "HJEM",
        translation13: "SIDER",
        translation14: "VÆRKTØJER",
        translation15: "NÆSTE",
        translation16: "TIL SIDE",
        translation17: "TILBAGE",
        translation18: "BAGGRUNDE",
        translation19: "TING",
        translation20: "FIGURER",
        translation21: "TEKSTBOKSE",
        translation22: "Begynd at skrive",
        translation23: "FÆRDIG",
        translation24: "Side",
        translation25: "Titelside",
        translation26: "Password",
        translation27: "Glemt dit password?",
        translation28: "ELLER",
        translation29: "OPRET NY KONTO",
        translation30: "Opret din konto",
        translation31: "Registrer dig",
        translation32: "LOGIN",
        translation33: "Nulstil dit password",
        translation34: "SEND LINK TIL NYT PASSWORD",
        translation35: "E-mail med link til nulstilling af password er sendt",
        translation36: "Tak!",
        translation37: "Din konto er oprettet. Bekræft din e-mail, før du logger ind",
        translation38: "Dette projekt er en del af et projekt, der har modtaget midler fra EU's Horizon 2020 Forsknings- og Innovationsprogram under tilskudsaftale nr. 822664",
        translation39: "OPRET NY",
        translation40: "Vil du slette?",
        translation41: "Tegning side",
        translation42: "af",
        translation43: "Titel",
        translation44: "Dit navn",
        translation45: "ANNULLER OG SLUK",
        translation46: "BLIVE VED",
        translation47: "REDIGER TITEL",
        translation48: "AFSLUT",
        translation49: "titel",
        translation50: "Indstillinger for forhåndsvisning og layout",
        translation51: "TILBAGE",
        translation52: "ANNULLER OG AFSLUT",
        translation54: "OFFENTLIG HISTORIE",
        translation55: "Er du sikker på, at du vil slette denne historie? Du kan ikke gendanne det.",
        translation56: "AFBESTILLE",
        translation57: "SLET",

        translation58: "Brugernavn eller e-mail",
        translation59: "SKIFT SPROG",
        translation60: "Tilføj historiens titel og dit navn",
        translation61: "Centrum",
        translation62: "Juster bunden",
        translation63: "Juster til venstre",
        translation64: "Forhåndsvisning",
        translation65: "Ingen historie endnu. Skab en!",
    },
    german: {
        translation0: "Neue Geschichte hinzufügen",
        translation1: "Neue Geschichte",
        translation2: "Meine Geschichten",
        translation3: "MIT MIR TEILEN",
        translation4: "GESCHICHTEN",
        translation5: "VIDEO TUTORIAL",
        translation6: "ÜBER MiCREATE",
        translation7: "ABMELDEN",
        translation8: "Mit mir teilen",
        translation9: "Teile deine Geschichte mit Freundinnen und Freunden",
        translation10: "E-Mail",
        translation11: "OK",
        translation12: "STARTSEITE",
        translation13: "SEITEN",
        translation14: "WERKZEUGE",
        translation15: "WEITER",
        translation16: "SEITE HINZUFÜGEN",
        translation17: "ZURÜCK",
        translation18: "HINTERGRÜNDE",
        translation19: "OBJEKTE",
        translation20: "EIGENSCHAFTEN",
        translation21: "Schreibkästchen",
        translation22: "Mit dem Schreiben starten...",
        translation23: "FERTIG",
        translation24: "Seite",
        translation25: "Titelseite",
        translation26: "Passwort",
        translation27: "Passwort vergessen?",
        translation28: "ODER",
        translation29: "ERSTELLE EIN NEUES KONTO",
        translation30: "Erstelle dein Konto",
        translation31: "REGISTRIEREN",
        translation32: "ANMELDEN",
        translation33: "Passwort zurücksetzen",
        translation34: "LINK ZUM ZURÜCKSETZEN SENDEN",
        translation35: "E-Mail zum Zurücksetzen wurde versendet",
        translation36: "Danke!",
        translation37: "Dein Konto wurde erstellt. Bitte bestätige deine E-Mail Adresse, bevor du dich einloggst. ",
        translation38: "Dieses Projekt ist Teil eines Projektes, welches durch das Horizont 2020 Forschungs- und Innovationsprogramm der Europäischen Union unter der Zuschussvereinbarung Nº822664 finnaziert wird",
        translation39: "ERSTELLE NEU",
        translation40: "Möchten Sie löschen?",
        translation41: "Zeichnungsseite",
        translation42: "von",
        translation43: "Titel",
        translation44: "Dein Name",
        translation45: "STORNIEREN UND BEENDEN",
        translation46: "FORTSETZEN",
        translation47: "TITEL BEARBEITEN",
        translation48: "FERTIG",
        translation49: "Titel",
        translation50: "Vorschau- und Layouteinstellungen",
        translation51: "ZURÜCK",
        translation52: "STORNIEREN UND BEENDEN",
        translation54: "PUBLISH STORY",
        translation55: "Möchten Sie diese Geschichte wirklich löschen? Sie können es nicht wiederherstellen.",
        translation56: "STORNIEREN",
        translation57: "LÖSCHEN",

        translation58: "Benutzername oder E-Mail-Adresse",
        translation59: "SPRACHE ÄNDERN",
        translation60: "Fügen Sie den Titel der Geschichte und Ihren Namen hinzu",
        translation61: "Center",
        translation62: "Unten ausrichten",
        translation63: "Linksbündig",
        translation64: "Vorschau",
        translation65: "Noch keine Geschichte. Erstelle einen!",
    },
    spanish: {
        translation0: "Añadir nueva historia",
        translation1: "Nueva historia",
        translation2: "Mis historias",
        translation3: "COMPARTIDO CONMIGO",
        translation4: "HISTORIAS",
        translation5: "VIDEO TUTORIAL",
        translation6: "SOBRE MiCREATE",
        translation7: "SALIR",
        translation8: "Compartido conmigo",
        translation9: "Comparte tu historia con amigos",
        translation10: "Correo electrónico",
        translation11: "DE ACUERDO",
        translation12: "INICIO",
        translation13: "PÁGINAS",
        translation14: "HERRAMIENTAS",
        translation15: "SIGUIENTE",
        translation16: "AÑADIR PÁGINA",
        translation17: "ATRÁS",
        translation18: "FONDOS",
        translation19: "OBJETOS",
        translation20: "PERSONAJES",
        translation21: "CAJAS DE TEXTO",
        translation22: "Empieza a escribir...",
        translation23: "HECHO",
        translation24: "Página",
        translation25: "Portada",
        translation26: "Contraseña",
        translation27: "¿Has olvidado tu contraseña?",
        translation28: "O",
        translation29: "CREAR NUEVA CUENTA",
        translation30: "Crea tu cuenta",
        translation31: "REGISTRARSE",
        translation32: "ENTRAR",
        translation33: "Reiniciar tu contraseña",
        translation34: "ENLACE DE REINICIO ENVIADO",
        translation35: "El enlace de reinicio se ha enviado",
        translation36: "¡Gracias!",
        translation37: "Tu cuenta se ha creado. \nAntes de entrar tienes que \nconfirmar tu dirección de \ncorreo electrónico",
        translation38: "Esta aplicación es parte de \nun proyecto que ha recibido \nfinanciación de la Unión \nEuropea, dentro del programa \nde investigación e innovación \nHorizonte 2020, con el número \nde acuerdo de subvención Nº822664",
        translation39: "CREAR",
        translation40: "¿Quieres eliminar?",
        translation41: "Página de dibujo",
        translation42: "de",
        translation43: "título",
        translation44: "Tu nombre",
        translation45: "CANCELAR Y SALIR",
        translation46: "SEGUIR",
        translation47: "EDITAR TÍTULO",
        translation48: "TERMINAR",
        translation49: "título",
        translation50: "Vista previa y configuración de diseño",
        translation51: "ESPALDA",
        translation52: "CANCELAR Y SALIR",
        translation54: "PUBLICAR HISTORIA",
        translation55: "¿Seguro que quieres borrar esta historia? No podrás recuperarlo.",
        translation56: "CANCELAR",
        translation57: "ELIMINAR",

        translation58: "Nombre de usuario o correo electrónico",
        translation59: "CAMBIAR IDIOMA",
        translation60: "Añade el título de la historia y tu nombre.",
        translation61: "Centrar",
        translation62: "Alinear abajo",
        translation63: "Alinear a la izquierda",
        translation64: "Avance",
        translation65: "Aún no hay historia. ¡Crea uno!",
    },
    catalan: {
        translation0: "Afegir nova història",
        translation1: "Nova història",
        translation2: "Les meves històries",
        translation3: "COMPARTIR AMB MI",
        translation4: "HISTÒRIES",
        translation5: "VÍDEO TUTORIAL",
        translation6: "SOBRE MiCREATE",
        translation7: "SORTIR",
        translation8: "Compartir amb mi",
        translation9: "Comparteix la teva història amb amics",
        translation10: "Correu electrònic",
        translation11: "D'ACORD",
        translation12: "INICI",
        translation13: "PÀGINES",
        translation14: "EINES",
        translation15: "SEGÜENT",
        translation16: "AFEGIR PÀGINA",
        translation17: "ENRERE",
        translation18: "FONS",
        translation19: "OBJECTES",
        translation20: "PERSONATGES",
        translation21: "CAIXES DE TEXT",
        translation22: "Comença a escriure...",
        translation23: "FET",
        translation24: "Pàgina",
        translation25: "Portada",
        translation26: "Contrasenya",
        translation27: "Has oblidat la teva contrasenya?",
        translation28: "O",
        translation29: "CREAR NOU COMPTE",
        translation30: "Crea el teu compte",
        translation31: "REGISTRAR-SE",
        translation32: "ENTRAR",
        translation33: "Reinicia la teva contrasenya",
        translation34: "ENLLAÇ DE REINICI ENVIAT",
        translation35: "L'enllaç de reinici s'ha enviat",
        translation36: "Gràcies!",
        translation37: "El teu compte s'ha creat.\nAbans d'entrar has de confirmar\nla teva adreça de correu electrònic.",
        translation38: "Aquesta aplicació és part d'un \nprojecte que ja rebut finançament\nde la Unió Europea, dins del \nprograma d'investigació i innovació\nHoritzó 2020, amb el número\nd'acord de subvenció Nº822664",
        translation39: "CREAR",
        translation40: "Voleu suprimir-ho?",
        translation41: "Pàgina de dibuix",
        translation42: "de",
        translation43: "títol",
        translation44: "El teu nom",
        translation45: "ANULAR I QUITAR",
        translation46: "CONTINUAR",
        translation47: "EDITAR TÍTOL",
        translation48: "ACABAT",
        translation49: "títol",
        translation50: "Configuració de vista prèvia i de disseny",
        translation51: "ESQUENA",
        translation52: "ANULAR I SORTIR",
        translation54: "PUBLICA HISTORYRIA",
        translation55: "Esteu segur que voleu suprimir aquesta història? No podreu recuperar-lo.",
        translation56: "CANCEL · LAR",
        translation57: "DELETA",

        translation58: "Nom d'usuari o correu electrònic",
        translation59: "CANVIAR D'IDIOMA",
        translation60: "Afegeix el títol de la història i el teu nom",
        translation61: "Centre",
        translation62: "Alineeu la part inferior",
        translation63: "Alinea a l'esquerra",
        translation64: "Vista prèvia",
        translation65: "Encara no hi ha història. Crea'n un!",
    },
    polish: {
        translation0: "Stwórz nową historię",
        translation1: "Nowa historia",
        translation2: "Moje historie",
        translation3: "UDOSTĘPNIONE DLA MNIE",
        translation4: "HISTORIE",
        translation5: "INSTRUKCJA WIDEO",
        translation6: "O MiCreate",
        translation7: "WYLOGUJ SIĘ",
        translation8: "Udostępnione dla mnie",
        translation9: "Udostępnij swoją historię znajomym",
        translation10: "Email",
        translation11: "ZATWIERDŹ",
        translation12: "STRONA GŁÓWNA",
        translation13: "STRONY",
        translation14: "NARZĘDZIA",
        translation15: "NASTĘPNY",
        translation16: "DODAJ STRONĘ",
        translation17: "WSTECZ",
        translation18: "TŁA",
        translation19: "PRZEDMIOTY",
        translation20: "POSTACIE",
        translation21: "DYMKI TEKSTÓW",
        translation22: "Zacznij wpisywać",
        translation23: "ZROBIONE",
        translation24: "Strona",
        translation25: "Strona główna",
        translation26: "hasło",
        translation27: "Zapomniałeś hasła?",
        translation28: "LUB",
        translation29: "STWÓRZ NOWE KONTO",
        translation30: "Stwórz swoje konto",
        translation31: "ZAREJESTRUJ SIĘ",
        translation32: "ZALOGUJ",
        translation33: "Zresetuj swoje hasło",
        translation34: "WYŚLIJ LINK RESETUJĄCY",
        translation35: "Email resetujący został wysłany",
        translation36: "Dziękuję!",
        translation37: "Twoje konto zostało utworzone. Przed zalogowaniem, potwierdź swój adres email",
        translation38: "Niniejsza aplikacja jest cześcią projektu, który otrzymał dofinansowanie w ramach programu badań i innowacji Unii Europejskiej Horyzont 2020 w ramach umowy grantowej o numerze 822664",
        translation39: "STWÓRZ",
        translation40: "Chcesz usunąć?",
        translation41: "Strona rysunku",
        translation42: "z",
        translation43: "tytuł",
        translation44: "Twoje imię",
        translation45: "ANULUJ I WYJDŹ",
        translation46: "KONTYNTYNUJ",
        translation47: "EDYTUJ TYTUŁ",
        translation48: "KONIEC",
        translation49: "tytuł",
        translation50: "Ustawienia podglądu i układu",
        translation51: "PLECY",
        translation52: "ANULUJ I WYJDŹ",
        translation54: "PUBLIKOWANA HISTORIA",
        translation55: "Czy na pewno chcesz usunąć tę historię? Nie będziesz w stanie go odzyskać.",
        translation56: "ANULUJ",
        translation57: "USUNĄĆ",

        translation58: "Nazwa użytkownika lub email",
        translation59: "ZMIEŃ JĘZYK",
        translation60: "Dodaj tytuł historii i swoje imię",
        translation61: "Środek",
        translation62: "Wyrównaj dół",
        translation63: "Wyrównaj do lewej",
        translation64: "Zapowiedź",
        translation65: "Nie ma jeszcze historii. Stworzyć jeden!",

    },
};
